import countries_code from "../../Data/countries_code.json";

const parsePhone = (val) => {
  const strVal = String(val || "").replace(/[^0-9]/g, "");
  if (!strVal) return { cCode: "62", pNum: "" };
  let matchCode = "62";
  let maxLen = 0;
  countries_code.forEach((c) => {
    const code = String(c.phone_code);
    if (strVal.startsWith(code) && code.length > maxLen) {
      matchCode = code;
      maxLen = code.length;
    }
  });
  const pNum = strVal.slice(matchCode.length);
  return { cCode: matchCode, pNum: pNum };
};

export default function C_V_PHONE({ value }) {
  if (!value) return null;

  const { cCode, pNum } = parsePhone(value);
  const formattedPNum = pNum ? pNum.replace(/(\d{3})(?=\d)/g, "$1-") : "";
  const displayPhone = `+${cCode}-${formattedPNum}`;

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        paddingLeft: "8px",
      }}
      title={displayPhone}
    >
      {displayPhone}
    </div>
  );
}
